import { useReadContract } from 'wagmi';
import { useCallback, useEffect } from 'react';

const useCustomContractRead = ({
  Adrress,
  Abi,
  FuncName,
  Args,
  select,
  onSuccess,
  onError,
  isEnabled = true,
  isWatch = true,
}) => {
  const _useReadContract = useReadContract({
    address: Adrress,
    abi: Abi,
    functionName: FuncName,
    args: Args,
    select,
    enabled: isEnabled,
    watch: isWatch,
    // select: (data) => {
    //   // Optional: Process data here to debounce or transform it
    //   return data;
    // },
  });

  const { data, isError, isLoading, error } = _useReadContract;
  
  

  const memoizedOnSuccess = useCallback(onSuccess, []);
  const memoizedOnError = useCallback(onError, []);

  // Perform the onSuccess operation when data is successfully fetched
  useEffect(() => {
    if (data && memoizedOnSuccess) {
      memoizedOnSuccess(data);
    }
  }, [data, memoizedOnSuccess]);

  // Handle errors
  useEffect(() => {
    if (isError && memoizedOnError) {
      memoizedOnError(error);
    }
  }, [isError, error, memoizedOnError]);

  return _useReadContract
};

export default useCustomContractRead;
